module.exports = __webpack_public_path__ + "img/logo.f55a6bec.png";